import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        markBlackFanFlag: false,
        sendPointsFlag:false,
        addGorupMemberFlag:false,
        userInfoListFlag:false,
        bindingVehiclesFlag:false,
        createPrivateChatFlag:false,
    },
    mutations: {
        changemarkBlackFanFlag(state) {
            state.markBlackFanFlag = !state.markBlackFanFlag
        },
        changesendPointsFlag(state){
        	state.sendPointsFlag = ! state.sendPointsFlag
        },
        changeaddGorupMemberFlag(state){
        	state.addGorupMemberFlag = ! state.addGorupMemberFlag
        },
        changeuserInfoListFlag(state){
            state.userInfoListFlag = ! state.userInfoListFlag
        },
        chamgebindingVehiclesFlag(state){
            state.bindingVehiclesFlag =! state.bindingVehiclesFlag
        },
        changecreatePrivateChatFlag(state){
            state.createPrivateChatFlag = ! state.createPrivateChatFlag
        }
    },
    actions: {

    }
})
